import styled from 'styled-components';

const Swiper = styled.div`
  display: flex;
  flex-wrap: nowrap;
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
  padding-top: 3px;
  padding-bottom: 16px;
  & > * {
    flex: 0 0 auto;
    margin-right: 12px;
  }
  & > *:first-child {
    margin-left: ${({ theme }) => theme.spacing(8)};
  }
  ::-webkit-scrollbar-track {
    display: none;
  }
  &::-webkit-scrollbar {
    display: none;
  }
  &::-webkit-scrollbar-thumb {
    display: none;
  }
`;

export default Swiper;
